<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import AppNavbar from './components/AppNavbar.vue'
import AppFooter from './components/AppFooter.vue'

// Scroll-progress bar (ported from the marketing site's App.vue)
const progress = ref(0)
const onScroll = () => {
  const h = document.documentElement
  const max = h.scrollHeight - h.clientHeight
  progress.value = max > 0 ? (h.scrollTop / max) * 100 : 0
}
onMounted(() => window.addEventListener('scroll', onScroll, { passive: true }))
onUnmounted(() => window.removeEventListener('scroll', onScroll))
</script>

<template>
  <div class="marketing-app">
    <div class="scroll-progress" :style="{ width: progress + '%' }"></div>
    <AppNavbar />
    <main>
      <RouterView v-slot="{ Component }">
        <transition name="page" mode="out-in">
          <component :is="Component" />
        </transition>
      </RouterView>
    </main>
    <AppFooter />
  </div>
</template>

<style scoped>
.scroll-progress {
  position: fixed; top: 0; left: 0; height: 3px; z-index: 200;
  background: var(--grad-primary);
  box-shadow: 0 0 12px rgba(26, 161, 168, 0.6);
  transition: width 0.1s linear;
}
main { min-height: 60vh; }
</style>
